/**
 * ParentNavigator — primary-adapter entry for parent-mode tabs.
 *
 * Today this is still mostly a seam: `navigationScreens` points here so the ports boundary is
 * the public entry point, while the shell itself lives in the legacy `ParentMainLayout`. What it
 * owns for real is the **thème de l'espace** — entrer dans l'espace parent bascule le DS sur le
 * thème parent, en sortir rend la main au précédent. C'est une préoccupation de coquille, donc
 * elle vit ici et pas dans un écran.
 *
 * TODO(ports): move the remaining shell concerns out of `ParentMainLayout` and into this file, in
 * this order — (1) the `Tab.Navigator` + screen registration, (2) family-account selection /
 * `selectedUser` (currently injected via `ParentTabScreenWrapper`'s `cloneElement`), (3) Intercom
 * + the password/payment guards. Once (1) lands, `ParentMainLayout` shrinks to the
 * guards.
 */
import React from "react"

import ParentMainLayout from "../../../../../common/components/family/ParentMainLayout"
import { useParentThemeScope } from "../../hooks/useParentThemeScope"

// Le layout legacy est en JS : ses props de navigation ne sont pas typées, on les relaie telles quelles.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function ParentNavigator(props: any) {
    useParentThemeScope()

    return <ParentMainLayout {...props} />
}
